module.exports = __webpack_public_path__ + "default-image.png?ee40c1291d3f0330f0ede618ff999baf";